import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
} from "reactstrap";
import { Formik } from "formik";
import PinInput from "react-pin-input";
import SvgImage from "../../Icons/Icons";
import "./index.css";
import * as Yup from "yup";
import { sendAnalitics } from "../../../services/Store/Actions/appActions";
import { editSalaryWalletAction, payDriverSalaryAction } from "../../../services/Store/Actions/driverslistActions";
import { useParams } from "react-router-dom";

function EditSalaryModal(props) {
  const dispatch = useDispatch();
  const {
    open,
    toggleModal,
    title,
    handleClick,
    handleClose,
    btn,
    balance,
    fastagBal,
    driverDetails,
  } = props;

  const { salaryWalletDetails } = useSelector(
    state => state?.driverlist,
  );
  console.log('meeeeeeeeeeeeeeeee',driverDetails)
  const {id}= useParams();
  const validationSchema = Yup.object().shape({
    amount: Yup.number().typeError("Only Numbers are allowed")
      .required("Required")
      .min(1, "Amount should be greater than 1"),
    // pin: Yup.string()
    //   .required("Required")
    //   .matches(/^[0-9]{4}$/, "Pin Must be exactly 4 digits"),
  });
  const {loader} = useSelector(
    (state) => state?.driverlist
  );

  // console.log("ok", props.fleetId);
  return (
    <div>
      <Modal
        isOpen={open}
        onHide={handleClose}
        className="positons1 settingModalMargin"
        toggle={toggleModal}
        aria-labelledby="myModalLabel2"
      >
         <div className="modal-content" style={{width:"530px", overflowY:"scroll", overflowX:"hidden"}} >
        <div className="modal-head-part">
          <p className="Add-balance-title">Edit Driver Salary</p>
          <Button
            type="button"
            className="close-btn"
            onClick={toggleModal}
            aria-label="Close"
          >
            <SvgImage name="CloseButtonLogo" />
          </Button>
        </div>
        <ModalBody>
          {/* <div className="card-wallet-icon-body3">
            <SvgImage
              name="tollBooth"
              height="43.81"
              width="43.81"
              classname="card-wallet-logo-BankLogo"
            />
            <div>
              <p className="body-sub-part1">Fastag Wallet Balance</p>
              <p className="body-sub-part2">{"₹" + balance}</p>
            </div>
          </div> */}
          <Formik
            enableReinitialize
            initialValues={{
              amount: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
                const data = {
                    phone: salaryWalletDetails.phone,
                    salary: values?.amount,
                    // eSLimit: props?.route?.params?.eSLimit,
                    // isESEnable: props?.route?.params?.isESEnable,
                  };
                dispatch(
                    editSalaryWalletAction(data, res => {
                    //   actions.setSubmitting(false);
                      if (res?.status == 200) {
                      //     setSuccessModal(true);
                      //     setSuccessText(
                      //       `Salary has been edited successfully.`
                      //     );
                        if (props?.route?.params?.path == '1') {
                          props?.route?.params?.handleSalary(values);
                        //   navigation.goBack();
                        }
                        else{
                        //   navigation.navigate('GlobalSuccessScreen',{
                        //     msg:'Salary details have been added successfully',
                        //     path: 'setSalary',
                        //     backHandle:'setSalary'
                        //   })
                        }
                        
                      }
                    }),
                  );
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <div className="sub-title-1">
                    <span class="circle-logo">1</span>
                    <label className="sub-head-3 ">Driver Name</label>
                  </div>
                  <div className="row">
                    <div className="col-10">
                      <p className="input-body-3 ">{salaryWalletDetails?.fullName}</p>
                    </div>

                    <div className="col-2">
                      <SvgImage name="lockLogo" />
                    </div>
                  </div>

                  <div className="input-amount-for-link"></div>
                </FormGroup>
                <FormGroup>
                  <div className="sub-title-1">
                    <span class="circle-logo">2</span>
                    <label className="sub-head-3 ">Contact Number</label>
                  </div>
                  <div className="row">
                    <div className="col-10">
                      <p className="input-body-3 ">{salaryWalletDetails.phone}</p>
                    </div>

                    <div className="col-2">
                      <SvgImage name="lockLogo" />
                    </div>
                  </div>

                  <div className="input-amount-for-link"></div>
                  {/* <p className="current-fastag-balance-for-recharge-wallet-id">
                    {`Early Salary Given: ₹ ${fastagBal}`}
                  </p> */}
                </FormGroup>
                <FormGroup>
                  <div className="sub-title-1">
                    <span class="circle-logo">3</span>
                    <p className="sub-title-recharge-fastag-Id">Enter amount</p>
                  </div>
                  <label for="html" className="label-body">
                    ₹
                  </label>
                  <input
                    type="text"
                    id="html"
                    className="input-body-1"
                    name="amount"
                    value={values.amount}
                    touched={touched.amount}
                    errors={errors.amount}
                    onBlur={handleBlur("amount")}
                    onChange={handleChange("amount")}
                    placeholder={salaryWalletDetails?.salary}
                  ></input>
                  <div className="input-amount"></div>
                  <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                    {errors.amount && touched.amount ? (
                      <div>*{errors.amount}</div>
                    ) : null}
                  </div>
                </FormGroup>
                <FormGroup>
                  <div>
                    <button type="submit" className="butt-recharge" disabled={loader?true:false}
                      style={{marginTop:"60px"}}
                      onClick={() => {
                      dispatch(
                          sendAnalitics("salary_payment_to_driver", {
                          amt: values.amount,
                        //   fleetId: props.fleetId
                          })
                        );
                      }}
                      >
                    {loader?"Please Wait":"Set Salary"}
                    
                    </button>
                  </div>
                  
                </FormGroup>
                {/* <div className="space-div"></div> */}
              </Form>
            )}
          </Formik>
        </ModalBody>
        </div>
      </Modal>
    </div>
  );
}
export default EditSalaryModal;
